export const ChevronRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6315 11.95L6.82821 4.1468C6.62488 3.94346 6.52229 3.69038 6.52046 3.38755C6.51846 3.08471 6.61904 2.8253 6.82221 2.6093C7.04221 2.3893 7.30463 2.2793 7.60946 2.2793C7.91429 2.2793 8.17471 2.3893 8.39071 2.6093L16.55 10.7565C16.72 10.9265 16.8432 11.1151 16.9197 11.3223C16.9964 11.5296 17.0347 11.7389 17.0347 11.95C17.0347 12.1612 16.9964 12.3705 16.9197 12.5778C16.8432 12.785 16.72 12.9735 16.55 13.1435L8.37171 21.3218C8.15171 21.5418 7.89446 21.6476 7.59996 21.6393C7.30546 21.631 7.04821 21.5168 6.82821 21.2968C6.62488 21.0768 6.51904 20.8195 6.51071 20.525C6.50238 20.2305 6.60821 19.9733 6.82821 19.7533L14.6315 11.95Z"
        fill="currentColor"
      />
    </svg>
  );
};
